export default [
  'Call your folks',
  'Everything in moderation, including moderation',
  'Most things are not as bad as you think they are',
  'An organized life is a calmer life.',
  'Our first teacher is our own heart',
  "Learn as you'd live forever; live as you'd die tomorrow.",
  "If you can't help, don't hinder.",
  'A human learns how to talk early, but how to keep silent late.',
  'A life of leisure and a life of laziness are different things.',
  'He who can take advice is sometimes superior to those who give it.',
  'Scheming seldom has success.',
  'Opportunities, like eggs, come one at a time.',
  'The passions are like fire and water: good servants but bad masters.',
  'You can get far with a lie, but not come back.',
  "He that tells a secret is another's servant.",
  'Despair never pays any debts.',
  "There are many witty men whose brains can't fill their bellies.",
  'Beware the anger of a patient man.',
  'A good remedy for anger is delay.',
  'You can run into debt, but you have to crawl out.',
  'True bravery is without witness.',
  'Hope is a good breakfast, but a poor supper.',
  "Wishes don't wash dishes.",
  'Speak kind words and you will hear kind answers.',
  'Confidence of success is almost success.',
  'Happiness is a form of courage.',
  'Anyone can start a rumor, but none can stop one.',
  'Without justice, courage is weak.',
  'The best things in life are free.',
  'We judge others by their acts, but ourselves by our intentions.',
  'Above all nations is humanity.',
  'Rough seas make good sailors.',
  'Wise fear begets care',
  'False friends are worse than open enemies.',
  'Truth may be blamed but never shamed.',
  'Age and marriage tame man and beast.',
  'Business goes where it is invited and stays where it is well treated.',
  'It is easy to be brave from a safe distance.',
  'Authority without wisdom is like a heavy axe without an edge.',
  'Getting what you go after is called success, but liking it while you are getting it is called happiness.',
  'Learning makes a good person better and a bad person worse.',
  'Compromise makes a good umbrella but a poor roof.',
  'People are punished by their sins, not for them.',
  'Whoever gossips to you will gossip of you.',
  'One deed is worth a thousand speeches.',
  'Pride costs us more than hunger, thirst and cold.',
  'Small circumstances produce great events.',
  'A nickel will get you on the subway, but garlic will get you a seat.',
  'Comparisons make enemies of our friends.',
  'Character is what you are in the dark when no one else is around.',
  'Young courage and old caution are a strong pair.',
  'Kindle not a fire that you cannot extinguish.',
  'If you have wit and learning, add to it wisdom and modesty.',
  'Nothing risked, nothing gained.',
  'Pride is the last vice a good man gets clear of.',
  'Dreams are what you hope for; reality is what you plan for.',
  'The less we know, the more we suspect.',
  'If the heart is right, the head cannot be very far wrong.',
  'A dollar saved is as good as a dollar earned.',
  'An ounce of discretion is worth a pound of wit.',
  'We seldom fear what we can laugh at.',
  'Every family has at least one black sheep.',
  'A thimbleful of experience is worth a tubful of knowledge.',
  'Constant occupation prevents temptation.',
  'Speak fair, think what you will.',
  'Whatever is worth doing is worth doing well.',
  'Every time you forgive a man you weaken him and strengthen yourself.',
  'The best fishing is in the deepest waters.',
  'It is better to know nothing than to half-know many things.',
  'You can build a house but you must make a home.',
  'Bad to do evil, but worse to boast about it.',
  'A good reputation stands still; a bad one runs.',
  'We are as big as the thing which bothers us.',
  'He who judges others condemns himself.',
  'Justice delayed is justice denied.',
  'True generosity is the ability to accept ingratitude.',
  "Defeat isn't bitter if you don't swallow it.",
  'Reality never surpasses imagination.',
  'Paddle your own canoe',
  'If passion drives, let reason hold the reins.',
  'All things were once impossible.',
  'To know all is to forgive all',
  'We never know the worth of water till the well is dry.',
  'All general rules have their exceptions',
  'Good fences make good neighbors',
  'Who rises late must trot all the day.',
  'Envy is destroyed by true friendship',
  'If you desire many things, many things will seem but a few.',
  'On an unknown path every foot is slow.',
  'It is easy for a man in health to preach patience to the sick.',
  'A little help is worth a lot of pity',
  'Success is a ladder that cannot be climbed with your hands in your pocket.',
  'Beauty without virtue is a rose without fragrance.',
  'To command one must learn to obey.',
  'Advice is least heeded when most needed.',
  'Never complain, never explain',
  'A forced kindness deserves no thanks',
  'Deceit is a lie which wears a smile.',
  'Knowledge is proud that he knows so much; wisdom is humble that he knows no more.',
  'Man changes often but improves seldom.',
  'Before honor is humility.',
  'One seldom meets a lonikeely lie.',
  'Those who do little expect the most.',
  'Wealth consists not of having great possessions but of having few wants.',
  'The lone sheep is in danger of the wolf.',
  'Give a civil answer to a civil question',
  'The more responsibilities a person assumes, the more likely they are to meet them.',
  "Never trust a man who doesn't trust others.",
  'He that shows a passion tells his enemy where he may hit him.',
  'Arrogance is a kingdom without a crown',
  "Don't value a gem by what it is set in.",
  'Life is a comedy to those who think, a tragedy to those who feel',
  'Change of fortune hurts a wise man no more than a change of the moon.',
  'A fool talks most when he has the least to say',
  'The generous can forget that they have given; but the grateful can never forget that they have received.',
  'A friend at hand is better than a relative at a distance.',
  'Education is the best provision for old age.',
  'Destiny leads the willing but drags the unwilling.',
  'A dog returns to where he has been fed.',
  'Caution is a downfall to ambition.',
  'Wide experience makes for deep tolerance',
  "A friend's envy is worse than an enemy's hatred.",
  'The surest way to make enemies is to have too many friends.',
  'Arrogance is a roadblock on the highway of wisdom.',
  "If you look back, you'll soon be going that way",
  'Every sin carries its own punishment',
  "You can put your boots in the oven but that doesn't make them biscuits.",
  'Before borrowing from a friend, decide which you need most.',
  'If everything is coming your way, then you’re in the wrong lane.',
  'If you are willing to admit faults, you have one less fault to admit.',
  'There is nothing permanent except change.',
  "When you're thirsty it's too late think about digging a well."
]
